import {gsap, ScrollTrigger} from "../LibrariesImport";

export default class BannerAnimation {
	static init() {
		const banner = document.querySelector(".banner-animation");
		if (!banner) {
			return;
		}

		if (ScrollTrigger.isTouch !== 1) {

			const elements = [
				".circle-1", ".circle-2", ".lightbulb", ".lightbulb-splash",
				".line-1", ".line-2", ".line-3"
			];

			gsap.set(elements, {willChange: "transform"});

			setTimeout(() => {
				banner.querySelector(".banner-image").classList.add("appear-ended");

				const parallaxElements = elements.map(selector => document.querySelector(selector)).filter(el => el !== null);

				document.addEventListener("mousemove", (e) => {
					const {clientX: x, clientY: y} = e;
					const {innerWidth: width, innerHeight: height} = window;

					const moveX = (x - width / 2) / width * 6;
					const moveY = (y - height / 2) / height * 6;

					parallaxElements.forEach((el, index) => {
						const depth = (index + 1) * 2;
						gsap.to(el, {
							x: moveX * depth,
							y: moveY * depth,
							duration: 1,
							ease: "power1.out",
							delay: 0.15
						});
					});
				});
			}, 1900);
		}
	}
}
